import React, { Component } from "react";
import { Button, Col, Form, message, Modal, Row, Spin, Typography, Select, Descriptions } from 'antd';

const axios = require('axios').default;
const { Title, Text } = Typography;
const { Option } = Select;
const moment = require('moment');


/**
 * Motivos de cancelación según el SAT (catálogo c_MotivoCancelacion)
 */
const MOTIVOS_CANCELACION = [
    { value: '02', label: '02 - Comprobante emitido con errores sin relación' },
    { value: '03', label: '03 - No se llevó a cabo la operación' },
    { value: '04', label: '04 - Operación nominativa relacionada en la factura global' },
]


/**
 *
 *
 * @class ModalCancelacion
 * @extends {Component}
 * @description Cancela una factura timbrada ante el SAT
 */
class ModalCancelacion extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            factura: {},
        }
    }

    formCancelacion = React.createRef();

    componentDidMount() {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');

        if (this.props.factura_id) {
            this.getFactura();
        }
    }

    /**
    * @memberof ModalCancelacion
    * @method getFactura
    * @description Trae la información de la factura a cancelar
    */
    getFactura = () => {
        this.setState({ loading: true })

        axios.get('/facturas/get', {
            params: {
                id: this.props.factura_id,
            }
        }).then(response => {
            this.setState({ factura: response.data.data })
        }).catch(error => {
            console.log(error)
            message.error('Error al cargar la información de la factura')
        }).finally(() => this.setState({ loading: false }))
    }

    /**
    * @memberof ModalCancelacion
    * @method onFinish
    * @description Envía el factura_id y la razón de cancelación al SAT
    */
    onFinish = (values) => {
        if (this.state.loading) return

        this.setState({ loading: true }, () => {
            axios.post('/syncfy/timbrado-v2/cancelacion', {
                factura_id: this.props.factura_id,
                razon: values.razon,
            })
                .then(response => {
                    message.success('Factura cancelada correctamente')
                    this.props.onClose()
                })
                .catch(error => {
                    console.log("error.response?.data?.data", error.response?.data?.data);
                    if (Array.isArray(error.response?.data?.data)) {
                        Modal.error({
                            title: 'Error al cancelar la factura',
                            content: <ul>
                                {error.response.data.data.map(e => <li>{e}</li>)}
                            </ul>
                        })
                    } else {
                        message.error(error.response?.data?.message || 'Error al cancelar la factura')
                    }
                })
                .finally(() => this.setState({ loading: false }))
        })
    }

    render() {
        const { formCancelacion, onFinish } = this;
        const { loading, factura } = this.state;

        return (
            <Spin spinning={loading}>
                <Title level={3} className="text-center">Cancelar factura</Title>

                <Descriptions
                    column={1}
                    bordered
                    size="small"
                    className="mt-1 mb-1"
                >
                    <Descriptions.Item label="Concepto">{factura?.concepto ?? '-'}</Descriptions.Item>
                    <Descriptions.Item label="UUID">{factura?.uuid ?? '-'}</Descriptions.Item>
                    <Descriptions.Item label="RFC Receptor">{factura?.receptor?.rfc ?? '-'}</Descriptions.Item>
                    <Descriptions.Item label="Fecha">{factura?.fecha ? moment(factura.fecha).format('DD-MM-YYYY') : '-'}</Descriptions.Item>
                    <Descriptions.Item label="Monto">$ {factura?.monto ? factura.monto.toMoney(true) : '0.00'} {factura?.moneda}</Descriptions.Item>
                </Descriptions>

                <Form
                    layout="vertical"
                    ref={formCancelacion}
                    onFinish={onFinish}
                >
                    <Row gutter={[16, 16]} justify="center">
                        <Col xs={24}>
                            <Form.Item
                                name="razon"
                                label="Razón de cancelación (SAT)"
                                rules={[{
                                    required: true,
                                    message: "Por favor, seleccione la razón de cancelación"
                                }]}
                            >
                                <Select placeholder="Seleccione la razón de cancelación">
                                    {MOTIVOS_CANCELACION.map(m => (
                                        <Option key={m.value} value={m.value}>{m.label}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row justify="center">
                        <Col span={24} className="text-center">
                            <Text type="secondary">Esta acción cancelará la factura ante el SAT y no se puede deshacer.</Text>
                        </Col>
                        <Col span={24} className="text-center mt-1">
                            <Form.Item>
                                <Button htmlType="submit" type="primary" danger loading={loading}>
                                    Cancelar factura
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Spin>
        )
    }
}


/**
 *@function ModalCancelacion
 *@description Modal contenedor para la cancelación de facturas
 */
export default function (props) {
    return (
        <Modal
            visible={props.visible}
            onCancel={props.onClose}
            title={null}
            footer={null}
            closable={true}
            maskClosable={true}
            destroyOnClose={true}
            zIndex={1000}
            width={600}
        >
            <ModalCancelacion {...props} />
        </Modal>
    )
}
